//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DeviceDataSummaryClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetDeviceDataSummaryDeviceDataSummaryQueryParameters = {
  patientId?: string | null;
  from?: Date | null;
  until?: Date | null;
  aggregationPeriod?: Types.AggregationPeriodEnum | null;
  deviceParameter?: Types.SummaryCalculatorEnum | null;
};

    
export function getDeviceDataSummaryUrl(patientId?: string | undefined, from?: Date | undefined, until?: Date | undefined, aggregationPeriod?: Types.AggregationPeriodEnum | undefined, deviceParameter?: Types.SummaryCalculatorEnum | undefined): string {
  let url_ = getBaseUrl() + "/api/deviceData/summary?";
if (patientId === null)
    throw new Error("The parameter 'patientId' cannot be null.");
else if (patientId !== undefined)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (from === null)
    throw new Error("The parameter 'from' cannot be null.");
else if (from !== undefined)
    url_ += "From=" + encodeURIComponent(from ? "" + Types.formatDate(from) : "") + "&";
if (until === null)
    throw new Error("The parameter 'until' cannot be null.");
else if (until !== undefined)
    url_ += "Until=" + encodeURIComponent(until ? "" + Types.formatDate(until) : "") + "&";
if (aggregationPeriod === null)
    throw new Error("The parameter 'aggregationPeriod' cannot be null.");
else if (aggregationPeriod !== undefined)
    url_ += "AggregationPeriod=" + encodeURIComponent("" + aggregationPeriod) + "&";
if (deviceParameter === null)
    throw new Error("The parameter 'deviceParameter' cannot be null.");
else if (deviceParameter !== undefined)
    url_ += "DeviceParameter=" + encodeURIComponent("" + deviceParameter) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDeviceDataSummaryDefaultOptions: UseQueryOptions<Types.SummaryDto, unknown, Types.SummaryDto> = {
  queryFn: __getDeviceDataSummary,
};
export function getGetDeviceDataSummaryDefaultOptions(): UseQueryOptions<Types.SummaryDto, unknown, Types.SummaryDto> {
  return getDeviceDataSummaryDefaultOptions;
};
export function setGetDeviceDataSummaryDefaultOptions(options: UseQueryOptions<Types.SummaryDto, unknown, Types.SummaryDto>) {
  getDeviceDataSummaryDefaultOptions = options;
}

export function getDeviceDataSummaryQueryKey(dto: GetDeviceDataSummaryDeviceDataSummaryQueryParameters): QueryKey;
export function getDeviceDataSummaryQueryKey(patientId?: string | undefined, from?: Date | undefined, until?: Date | undefined, aggregationPeriod?: Types.AggregationPeriodEnum | undefined, deviceParameter?: Types.SummaryCalculatorEnum | undefined): QueryKey;
export function getDeviceDataSummaryQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId, from, until, aggregationPeriod, deviceParameter,  } = params[0] as GetDeviceDataSummaryDeviceDataSummaryQueryParameters;

    return trimArrayEnd([
        'DeviceDataSummaryClient',
        'getDeviceDataSummary',
        patientId as any,
        from as any,
        until as any,
        aggregationPeriod as any,
        deviceParameter as any,
      ]);
  } else {
    return trimArrayEnd([
        'DeviceDataSummaryClient',
        'getDeviceDataSummary',
        ...params
      ]);
  }
}
function __getDeviceDataSummary(context: QueryFunctionContext) {
  return Client.getDeviceDataSummary(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as Date | undefined,       context.queryKey[4] as Date | undefined,       context.queryKey[5] as Types.AggregationPeriodEnum | undefined,       context.queryKey[6] as Types.SummaryCalculatorEnum | undefined    );
}

export function useGetDeviceDataSummaryQuery<TSelectData = Types.SummaryDto, TError = unknown>(dto: GetDeviceDataSummaryDeviceDataSummaryQueryParameters, options?: UseQueryOptions<Types.SummaryDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param patientId (optional) Patient id
 * @param from (optional) Summary period start date
 * @param until (optional) Summary period end date
 * @param aggregationPeriod (optional) The period for which data should be aggregated
 * @param deviceParameter (optional) Type of statistics for summary
 */
export function useGetDeviceDataSummaryQuery<TSelectData = Types.SummaryDto, TError = unknown>(patientId?: string | undefined, from?: Date | undefined, until?: Date | undefined, aggregationPeriod?: Types.AggregationPeriodEnum | undefined, deviceParameter?: Types.SummaryCalculatorEnum | undefined, options?: UseQueryOptions<Types.SummaryDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDeviceDataSummaryQuery<TSelectData = Types.SummaryDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SummaryDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let patientId: any = undefined;
  let from: any = undefined;
  let until: any = undefined;
  let aggregationPeriod: any = undefined;
  let deviceParameter: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId, from, until, aggregationPeriod, deviceParameter,  } = params[0] as GetDeviceDataSummaryDeviceDataSummaryQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, from, until, aggregationPeriod, deviceParameter, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.SummaryDto, TError, TSelectData>({
    queryFn: __getDeviceDataSummary,
    queryKey: getDeviceDataSummaryQueryKey(patientId, from, until, aggregationPeriod, deviceParameter),
    ...getDeviceDataSummaryDefaultOptions as unknown as UseQueryOptions<Types.SummaryDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * @param patientId (optional) Patient id
 * @param from (optional) Summary period start date
 * @param until (optional) Summary period end date
 * @param aggregationPeriod (optional) The period for which data should be aggregated
 * @param deviceParameter (optional) Type of statistics for summary
 */
export function setGetDeviceDataSummaryData(queryClient: QueryClient, updater: (data: Types.SummaryDto | undefined) => Types.SummaryDto, patientId?: string | undefined, from?: Date | undefined, until?: Date | undefined, aggregationPeriod?: Types.AggregationPeriodEnum | undefined, deviceParameter?: Types.SummaryCalculatorEnum | undefined) {
  queryClient.setQueryData(getDeviceDataSummaryQueryKey(patientId, from, until, aggregationPeriod, deviceParameter),
    updater
  );
}

/**
 * @param patientId (optional) Patient id
 * @param from (optional) Summary period start date
 * @param until (optional) Summary period end date
 * @param aggregationPeriod (optional) The period for which data should be aggregated
 * @param deviceParameter (optional) Type of statistics for summary
 */
export function setGetDeviceDataSummaryDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SummaryDto | undefined) => Types.SummaryDto) {
  queryClient.setQueryData(queryKey, updater);
}